export namespace Reports {
  export interface ReportDTO {
    readonly status: ReportStatus;
    readonly file_url: string;
    readonly is_new?: boolean;
    readonly generated_at?: string;
  }

  export interface ReportQueryData extends ReportDTO {
    readonly type: ReportTypes;
    readonly report_id?: string;
    readonly workspace_id?: string;
    readonly field_count?: number;
    readonly source?: string;
    readonly max_cloud_coverage?: number;
    readonly date_range_count?: number;
  }

  export enum ReportTypes {
    NDVI_CHANGE = 'ndvi_change',
    VARIABILITY_CHANGE = 'variability_change',
    FIELD_INSIGHTS = 'field_insights',
    TIME_SERIES_XLSX = 'time_series_xlsx',
    HISTOGRAM_XLSX = 'histogram_xlsx',
  }

  export enum ReportStatus {
    GENERATING = 'GENERATING',
    AVAILABLE = 'AVAILABLE',
    ERROR = 'ERROR',
  }

  export interface BulkXlsxResponseDTO {
    key: string;
    status: ReportStatus;
    file_url: string;
    metadata?: Record<string, unknown>;
  }
}
